"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = exports.SystemLogin = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const notistack_1 = require("notistack");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const mui_inputs_core_1 = require("@framework/mui-inputs-core");
const mui_page_layout_1 = require("@framework/mui-page-layout");
const mui_form_1 = require("@framework/mui-form");
const provider_api_1 = require("@framework/provider-api");
const provider_user_1 = require("@framework/provider-user");
const react_hooks_1 = require("@framework/react-hooks");
const validation_1 = require("./validation");
const buttons_1 = require("./buttons");
const password_change_required_1 = require("./password-change-required");
const SystemLogin = () => {
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const state = location.state;
    const redirectTo = state?.from || "/dashboard";
    const user = (0, provider_user_1.useUser)();
    const api = (0, provider_api_1.useApi)();
    const [customerLogo, setCustomerLogo] = (0, react_1.useState)(null);
    const { fn: fetchCustomerLogo } = (0, react_hooks_1.useApiCall)(apiClient => apiClient.fetchJson({
        url: "/info/customer-logo",
    }), { error: false, success: false });
    /* javascript-obfuscator:disable */
    const baseUrl = process.env.BE_URL;
    /* javascript-obfuscator:enable */
    (0, react_1.useEffect)(() => {
        if (state?.reason === "session_expired") {
            (0, notistack_1.enqueueSnackbar)(formatMessage({ id: "snackbar.sessionExpired" }), {
                variant: "warning",
            });
            window.history.replaceState({ from: redirectTo }, document.title);
        }
    }, [state?.reason, redirectTo, formatMessage]);
    const handleSubmit = async (values, form) => {
        await user.logIn(values, redirectTo).catch((e) => {
            if (e.status === 400) {
                if (e.interlayerErrors?.length) {
                    e.interlayerErrors.forEach(({ key }) => {
                        form.setError("password", { type: "custom", message: `form.validations.${key}` });
                    });
                }
            }
            else if (e.status === 403) {
                if (e.interlayerErrors?.length) {
                    const shouldOpenSetNewPassword = (0, password_change_required_1.hasPasswordChangeRequiredError)(e.interlayerErrors);
                    e.interlayerErrors.forEach(({ key }) => {
                        (0, notistack_1.enqueueSnackbar)(formatMessage({ id: `snackbar.${key}` }), {
                            variant: (0, password_change_required_1.getLoginErrorSnackbarVariant)(key),
                        });
                    });
                    if (shouldOpenSetNewPassword) {
                        navigate("/set-new-password", { state: { login: values.login } });
                    }
                }
            }
            else if (e.status) {
                (0, notistack_1.enqueueSnackbar)(formatMessage({ id: `snackbar.${e.message}` }), { variant: "error" });
            }
            else {
                console.error(e);
                (0, notistack_1.enqueueSnackbar)(formatMessage({ id: "snackbar.error" }), { variant: "error" });
            }
        });
    };
    const onMessage = (event) => {
        if (event.origin === baseUrl) {
            api.setToken(event.data);
            void user.getProfile(redirectTo);
        }
    };
    (0, react_hooks_1.useDidMountEffect)(() => {
        void user.getProfile(redirectTo);
    }, [user.isAuthenticated(), redirectTo]);
    (0, react_1.useEffect)(() => {
        window.addEventListener("message", onMessage, false);
        return () => {
            window.removeEventListener("message", onMessage);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        void fetchCustomerLogo().then((json) => {
            if (json?.value) {
                setCustomerLogo(json.value);
            }
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "calc(100vh - 64px)",
            maxWidth: 500,
            margin: "0 auto",
        }, children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { item: true, sm: 12, children: [customerLogo ? ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                        display: "flex",
                        justifyContent: "center",
                        mb: 2,
                    }, children: (0, jsx_runtime_1.jsx)(material_1.Box, { alt: "", component: "img", src: `data:image/jpeg;charset=utf-8;base64,${customerLogo}`, sx: { maxHeight: 120, maxWidth: "100%", objectFit: "contain" } }) })) : null, (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.guest.login" }), (0, jsx_runtime_1.jsxs)(mui_form_1.FormWrapper, { showButtons: false, showPrompt: false, onSubmit: handleSubmit, validationSchema: validation_1.validationSchema, initialValues: {
                        password: "",
                        login: "",
                    }, testId: "SystemLogin", children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "login", autoComplete: "username" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.PasswordInput, { name: "password", autoComplete: "current-password" }), (0, jsx_runtime_1.jsx)(buttons_1.LoginButtons, {})] })] }) }));
};
exports.SystemLogin = SystemLogin;
exports.Login = exports.SystemLogin;
//# sourceMappingURL=index.js.map